<template>
  <el-upload
    ref="upload"
    :limit="limit"
    v-bind="$attrs"
    list-type="picture-card"
    class="C-Upload"
    :on-success="handleSuccess"
    :on-error="handleError"
    :on-progress="handleProgress"
    :with-credentials="true"
    :data="{
      category: ''
    }"
    :action="action"
  >
    <span class="img-placeholder">
      <em class="el-icon-plus"></em>
      <span>添加文件</span>
    </span>

    <div slot="file" slot-scope="{ file }" class="image-slot">
      <el-progress
        type="circle"
        :percentage="Math.ceil(file.percentage)"
        v-if="file.status === 'uploading'"
        :width="80"
      ></el-progress>
      <template v-else>
        <img class="el-upload-list__item-thumbnail" :src="file._url" alt="" />
        <span class="el-upload-list__item-actions flex-box">
          <div class="preview-btn" @click="handlePreview(file)">预览</div>
          <div class="delete-btn" @click="handleDelete(file)">删除</div>
        </span>
      </template>
    </div>
  </el-upload>
</template>

<script>
import Preview from './Preview.vue'
import { getVideoBase64 } from './utils'

export const videoType = ['avi', 'mov', 'rmvb', 'rm', 'flv', 'mp4', '3gp']

// 这是一个重复的轮子，但是没有办法，现有的组件不能够满足涉及那边的样式，只能自己重新设计
export default {
  name: 'CUpload',

  props: {
    value: {
      type: [Array],
      default: () => []
    },
    limit: {
      type: Number,
      default: 10
    }
  },

  data() {
    return {
      action: `${location.protocol}${process.env.VUE_APP_API}/cust-complain-app/upload/fileUpload`
    }
  },

  methods: {
    handleError(error, file, fileList) {
      this.$message.error('上传失败')
      this.$libTrack?.error?.('上传图片失败', error || {}, 'uploadfile-error')
    },

    handleProgress(event, file, fileList) {},

    async handleSuccess(response, file, fileList) {
      try {
        const { absoluteUrl, imgPath } = response?.data
        // 需要判断是图片还是视频
        const isVideo = videoType.includes(imgPath.split('.')[1])
        if (isVideo) {
          const base64 = await getVideoBase64(absoluteUrl)
          file._type = 'video'
          file._url = base64 // 视频第一帧图片
        } else {
          file._type = 'image'
          file._url = absoluteUrl
        }
        file.absoluteUrl = absoluteUrl
        file.relativeUrl = imgPath
        this.$emit('input', [...this.value, absoluteUrl])
      } catch (error) {
        console.error('error', error)
      }
    },

    handlePreview(file) {
      const vm = this.$createDialog(
        Preview,
        {
          file
        },
        {
          title: '资源预览',
          width: '80%'
        }
      )
      vm.show()
    },

    handleDelete(file) {
      this.$refs.upload.handleRemove(file)
      const index = this.value.findIndex(url => url === file.url)
      this.value.splice(index, 1)
      this.$emit('input', [...this.value])
    }
  }
}
</script>

<style lang="stylus" scoped>
.C-Upload {
  /deep/ .el-upload-list--picture-card .el-progress {
    width: 100%;
  }

  /deep/ .el-upload--picture-card {
    height: 80px;
    width: 80px;
    line-height: 80px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    height: 80px;
    width: 80px;
  }

  .image-slot {
    height: 100%;
  }

  .flex-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;

    .preview-btn {
      width: 60px;
      height: 34px;
      background: #1F5DE9;
      border-radius: 2px;
      display: inline-block;
      font-size: 14px;
      margin: 8px 0;
      padding: 4px 0;
    }

    .delete-btn {
      font-size: 14px;
      width: 60px;
      height: 22px;
      background: #E4180C;
      border-radius: 2px;
      display: inline-block;
      font-size: 14px;
      margin: 0;
    }
  }
}
</style>
